import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import claraviewBrand from "../../assets/claraViewMedia/landing-page-brand.svg";
import "../../Components/ClaraView/index.css"
import { unsubscribeEmail } from '../../Services/APIs/report';

const Unsubscribe = () => {
    const { id } = useParams();
    const [isUnsubscribed, setIsUnsubscribed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleUnsubscribe = async () => {
        setLoading(true);
        setError(null);
        try {
            await unsubscribeEmail(id);
            setIsUnsubscribed(true);
        } catch (err) {
            setError("Failed to unsubscribe. Please try again later.");
            console.error("Unsubscribe error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-full flex-col flex bg-[#F3F7F5] font-novatica">
            <div className="flex items-center justify-center pt-10">
                <img src={claraviewBrand} alt="claraview-logo" className='h-8' />
            </div>
            <div className="flex-grow flex items-center justify-center px-6">
                <div className="bg-white p-8 rounded-lg shadow-md text-center">
                    {loading ? (
                        <div className="flex flex-col justify-center items-center">
                            <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
                            <p className="text-claraview-tertiary text-center">Unsubscribing...</p>
                        </div>
                    ) : error ? (
                        <>
                            <h2 className="text-2xl font-bold text-red-600 mb-4">Error</h2>
                            <p className="text-gray-700">{error}</p>
                        </>
                    ) : isUnsubscribed ? (
                        <>
                            <h2 className="text-2xl font-bold text-green-600 mb-4">Successfully Unsubscribed!</h2>
                            <p className="text-gray-700">You will no longer receive email notifications from us.</p>
                        </>
                    ) : (
                        <>
                            <h2 className="text-2xl font-bold text-claraview-tertiary mb-4">Unsubscribe from Email Notifications</h2>
                            <p className="text-gray-700 mb-6">Are you sure you want to unsubscribe from all email notifications?</p>
                            <button
                                onClick={handleUnsubscribe}
                                className="text-white px-4 rounded-lg w-4/5 font-medium text-xl h-12 shadow-inner claraview-cta-button"
                            >
                                Yes, Unsubscribe
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Unsubscribe;
